import React from 'react';

export const PersonBubbleHouse = () => (
  <g transform="matrix(16.869308,0,0,16.869308,-2158.9446,-6089.3976)">
    <path
      d="M 0.62,182.5 A 1.623,1.623 0 0 1 0.005,180.921 15.02,15.02 0 0 1 12.022,166.81 c 1.27,-0.257 2.588,-0.28 3.92,-0.414 a 1.539,1.539 0 0 0 -0.131,-0.159 12.069,12.069 0 0 1 -3.582,-6.442 0.787,0.787 0 0 0 -0.45,-0.48 4.538,4.538 0 0 1 -3.279,-4.309 4.448,4.448 0 0 1 3.265,-4.3 c 0.376,-0.119 0.443,-0.344 0.512,-0.67 a 11.965,11.965 0 0 1 23.435,0 0.789,0.789 0 0 0 0.64,0.7 4.454,4.454 0 0 1 3.143,4.267 4.514,4.514 0 0 1 -3.161,4.268 c -0.218,0.07 -0.517,0.273 -0.554,0.459 a 12.353,12.353 0 0 1 -3.86,6.762 h 0.765 a 15.069,15.069 0 0 1 15.315,14.8 1.448,1.448 0 0 1 -0.626,1.2 z m 1.46,-2.037 h 43.838 a 12.937,12.937 0 0 0 -13.865,-11.9 c -0.056,1.053 -0.041,2.117 -0.18,3.159 A 7.965,7.965 0 0 1 16.12,171.714 c -0.139,-1.042 -0.123,-2.1 -0.178,-3.157 A 12.938,12.938 0 0 0 2.08,180.46 m 31.9,-25.988 a 26.219,26.219 0 0 1 -6.993,-1.2 12.634,12.634 0 0 1 -5.9,-3.7 A 9.517,9.517 0 0 1 14,153.45 c 0,1.281 -0.016,2.526 0,3.77 a 9.919,9.919 0 0 0 5.52,9.177 10.03,10.03 0 0 0 13.665,-4.97 c 0.916,-2.244 0.814,-4.553 0.8,-6.956 m -0.031,-2 A 9.962,9.962 0 0 0 23.925,142.5 c -5.028,0.019 -10.076,4.6 -9.765,8.833 2.108,0 5.742,-1.744 5.849,-4.827 a 0.961,0.961 0 0 1 0.989,-1 0.921,0.921 0 0 1 0.972,0.877 4.294,4.294 0 0 0 2.129,3.282 c 2.949,2.047 6.335,2.587 9.856,2.806 m -16.009,15.885 c 0.058,1.164 0.055,2.12 0.162,3.064 a 5.98,5.98 0 0 0 8.442,4.48 c 2.944,-1.5 3.761,-4.17 3.354,-7.508 a 14.414,14.414 0 0 0 -1.856,0.386 12.037,12.037 0 0 1 -8.078,0.008 17.805,17.805 0 0 0 -2.023,-0.433 m -5.979,-15.607 a 2.381,2.381 0 0 0 -1.448,2.3 2.345,2.345 0 0 0 1.448,2.188 z m 24.042,4.4 a 2.231,2.231 0 0 0 1.481,-2.19 2.2,2.2 0 0 0 -1.481,-2.118 z"
      transform="translate(128,242.498)"
      fill="#1875f0"
    />
    <path
      d="m 236.021,17.241 a 31.921,31.921 0 0 1 -1.151,4.571 15.5,15.5 0 0 1 -12.265,9.935 15.7,15.7 0 0 1 -16.538,-8 15.4,15.4 0 0 1 0.9,-16.934 14.918,14.918 0 0 1 9.384,-6.366 15.523,15.523 0 0 1 15.149,4.453 15.357,15.357 0 0 1 4.413,9.362 4.624,4.624 0 0 0 0.1,0.478 z M 219.973,29.99 A 14,14 0 1 0 206.02,15.944 14.045,14.045 0 0 0 219.973,29.99"
      transform="translate(-44.02,361)"
      fill="#748498"
    />
    <path
      d="m 310.2,215.756 a 5,5 0 1 1 -4.951,-5.009 5.046,5.046 0 0 1 4.951,5.009 m -2,-0.019 a 3,3 0 1 0 -2.974,3 3.019,3.019 0 0 0 2.974,-3"
      transform="translate(-125.207,183.25)"
      fill="#748498"
    />
    <path
      d="m 250.716,259.452 a 4,4 0 1 1 -3.973,-3.987 4.034,4.034 0 0 1 3.973,3.987 m -4,-1.987 a 2,2 0 1 0 2,1.975 2.01,2.01 0 0 0 -2,-1.975"
      transform="translate(-76.722,145.533)"
      fill="#748498"
    />
    <path
      d="m 13.286,331.35 a 12.938,12.938 0 0 1 13.861,-11.907 c 0.055,1.052 0.039,2.114 0.178,3.157 a 7.965,7.965 0 0 0 15.753,0.008 c 0.139,-1.043 0.124,-2.106 0.18,-3.159 a 12.936,12.936 0 0 1 13.865,11.9 z"
      transform="translate(116.795,91.607)"
      fill="#eaeff7"
    />
    <path
      d="m 109.348,203.335 c 0.013,2.4 0.115,4.712 -0.8,6.956 a 10.029,10.029 0 0 1 -13.665,4.97 9.919,9.919 0 0 1 -5.52,-9.177 c -0.019,-1.245 0,-2.49 0,-3.77 a 9.517,9.517 0 0 0 7.1,-3.879 12.632,12.632 0 0 0 5.9,3.7 26.22,26.22 0 0 0 6.994,1.2 m -7.95,6.052 c -0.28,1.257 -0.935,1.916 -1.939,1.965 -1.054,0.052 -1.73,-0.557 -2.174,-1.947 h -1.9 a 3.99,3.99 0 0 0 4.092,3.946 3.936,3.936 0 0 0 3.826,-3.964 z m -3.063,-3.053 a 2.99,2.99 0 0 0 -3.168,-2.963 2.883,2.883 0 0 0 -2.731,2.966 h 1.884 c 0.157,-0.522 0.423,-0.966 1.047,-0.963 0.624,0.003 0.883,0.452 1.034,0.96 z m 4,0 c 0.147,-0.552 0.431,-0.951 1.021,-0.958 0.625,-0.008 0.89,0.44 1.044,0.944 h 1.935 a 2.979,2.979 0 0 0 -3.088,-2.953 2.914,2.914 0 0 0 -2.822,2.967 z"
      transform="translate(52.637,193.635)"
      fill="#ffffff"
    />
    <path
      d="m 110.157,163.249 c -3.521,-0.22 -6.907,-0.759 -9.856,-2.806 a 4.294,4.294 0 0 1 -2.129,-3.282 0.921,0.921 0 0 0 -0.971,-0.877 0.962,0.962 0 0 0 -0.99,1 c -0.106,3.082 -3.74,4.831 -5.848,4.827 -0.311,-4.229 4.737,-8.815 9.765,-8.834 a 9.962,9.962 0 0 1 10.029,9.974"
      transform="translate(51.797,231.723)"
      fill="#ffffff"
    />
    <path
      d="m 114.622,318.417 a 17.806,17.806 0 0 1 2.023,0.433 12.037,12.037 0 0 0 8.078,-0.008 14.386,14.386 0 0 1 1.856,-0.386 c 0.407,3.338 -0.409,6.01 -3.354,7.508 a 5.98,5.98 0 0 1 -8.442,-4.484 c -0.107,-0.944 -0.1,-1.9 -0.162,-3.064"
      transform="translate(31.324,92.438)"
      fill="#ffffff"
    />
    <path
      d="m 68.63,218.736 v 4.484 a 2.344,2.344 0 0 1 -1.448,-2.188 2.381,2.381 0 0 1 1.448,-2.3"
      transform="translate(71.338,176.512)"
      fill="#ffffff"
    />
    <path
      d="m 229.995,223.641 v -4.308 a 2.2,2.2 0 0 1 1.481,2.118 2.231,2.231 0 0 1 -1.481,2.19"
      transform="translate(-65.985,176.008)"
      fill="#ffffff"
    />
    <path
      d="m 231.109,40.718 a 14,14 0 1 1 14.045,-13.953 14.045,14.045 0 0 1 -14.045,13.953 m 2,-22.607 -1,-0.884 c -0.764,-0.677 -1.132,-0.681 -1.885,-0.012 q -4.226,3.753 -8.454,7.5 a 1.665,1.665 0 0 0 -0.619,1.356 c 0.018,2.436 0.005,4.872 0.009,7.307 0,1 0.343,1.336 1.363,1.336 q 8.65,0 17.3,0 c 1,0 1.334,-0.343 1.336,-1.363 0,-1.978 0.013,-3.956 0,-5.933 -0.02,-2.574 0.289,-1.83 -1.6,-3.6 a 1.3,1.3 0 0 1 -0.379,-0.833 c -0.036,-1.6 -0.016,-3.206 -0.018,-4.809 0,-1.166 -0.3,-1.46 -1.489,-1.461 q -1.53,0 -3.06,0 c -1.083,0 -1.35,0.236 -1.5,1.393"
      transform="translate(-55.156,350.271)"
      fill="#ffffff"
    />
    <path
      d="m 318.978,226.517 a 3,3 0 1 1 -2.985,-2.99 3.019,3.019 0 0 1 2.985,2.99"
      transform="translate(-135.983,172.471)"
      fill="#ffffff"
    />
    <path
      d="m 257.487,268.237 a 2,2 0 1 1 -1.99,1.986 2.011,2.011 0 0 1 1.99,-1.986"
      transform="translate(-87.494,134.76)"
      fill="#ffffff"
    />
    <path
      d="m 133.9,268.388 h 1.906 a 3.936,3.936 0 0 1 -3.826,3.964 3.99,3.99 0 0 1 -4.092,-3.946 h 1.9 c 0.444,1.39 1.12,2 2.174,1.947 1,-0.05 1.659,-0.708 1.938,-1.965"
      transform="translate(20.131,134.633)"
      fill="#1875f0"
    />
    <path
      d="m 114.892,232.888 h -1.935 c -0.151,-0.507 -0.413,-0.957 -1.034,-0.96 -0.621,-0.003 -0.891,0.441 -1.047,0.963 h -1.884 a 2.883,2.883 0 0 1 2.731,-2.966 2.99,2.99 0 0 1 3.168,2.963"
      transform="translate(36.08,167.08)"
      fill="#1875f0"
    />
    <path
      d="m 161.944,232.887 h -1.909 a 2.914,2.914 0 0 1 2.822,-2.967 2.979,2.979 0 0 1 3.088,2.953 h -1.935 c -0.153,-0.5 -0.419,-0.952 -1.044,-0.944 -0.59,0.007 -0.875,0.406 -1.021,0.958"
      transform="translate(-6.977,167.08)"
      fill="#1875f0"
    />
    <path
      d="m 254.6,39.643 c 0.149,-1.157 0.416,-1.392 1.5,-1.393 q 1.53,0 3.06,0 c 1.189,0 1.489,0.295 1.49,1.461 0,1.6 -0.018,3.207 0.018,4.809 a 1.3,1.3 0 0 0 0.379,0.833 c 1.89,1.77 1.581,1.027 1.6,3.6 0.016,1.978 0.005,3.956 0,5.933 0,1.02 -0.335,1.363 -1.336,1.363 q -8.65,0 -17.3,0 c -1.02,0 -1.362,-0.335 -1.363,-1.336 0,-2.436 0.009,-4.872 -0.009,-7.307 a 1.666,1.666 0 0 1 0.619,-1.356 q 4.237,-3.741 8.454,-7.5 c 0.753,-0.669 1.122,-0.665 1.886,0.012 l 1,0.884 m -1.922,0.977 a 1.6,1.6 0 0 0 -0.2,0.122 Q 248.7,44.1 244.928,47.47 a 0.966,0.966 0 0 0 -0.264,0.637 c -0.026,1.124 -0.012,2.248 -0.012,3.373 v 2.727 h 5 c 0,-1.936 -0.006,-3.829 0,-5.721 0,-0.855 0.369,-1.225 1.214,-1.232 1.208,-0.01 2.415,-0.013 3.623,0 a 1.032,1.032 0 0 1 1.158,1.161 c 0.015,0.832 0,1.666 0,2.5 v 3.294 h 5 c 0,-1.54 -0.09,-3.043 0.026,-4.531 a 3.09,3.09 0 0 0 -1.449,-3.258 1.358,1.358 0 0 1 -0.584,-1.3 c 0.021,-1.416 0.007,-2.832 0.007,-4.247 v -0.59 h -2 c 0,0.5 -0.007,0.978 0,1.452 a 1.035,1.035 0 0 1 -0.59,1.076 1.048,1.048 0 0 1 -1.2,-0.256 c -0.71,-0.642 -1.432,-1.271 -2.181,-1.933 m -0.984,13.6 h 1.919 V 49.276 H 251.7 Z"
      transform="translate(-76.653,328.74)"
      fill="#1875f0"
    />
    <path
      d="m 263.479,51.576 c 0.749,0.663 1.471,1.292 2.181,1.933 a 1.048,1.048 0 0 0 1.2,0.256 1.034,1.034 0 0 0 0.59,-1.076 c -0.008,-0.474 0,-0.948 0,-1.452 h 2 v 0.59 c 0,1.416 0.014,2.832 -0.007,4.247 a 1.358,1.358 0 0 0 0.584,1.3 3.09,3.09 0 0 1 1.449,3.258 c -0.116,1.487 -0.026,2.991 -0.026,4.53 h -5 q 0,-1.652 0,-3.294 c 0,-0.833 0.011,-1.666 0,-2.5 a 1.032,1.032 0 0 0 -1.158,-1.161 c -1.207,-0.014 -2.415,-0.012 -3.623,0 -0.845,0.007 -1.21,0.377 -1.214,1.232 -0.008,1.892 0,3.785 0,5.721 h -5 v -2.725 c 0,-1.124 -0.014,-2.249 0.012,-3.373 a 0.967,0.967 0 0 1 0.264,-0.637 q 3.763,-3.38 7.556,-6.728 a 1.6,1.6 0 0 1 0.2,-0.122"
      transform="translate(-87.451,317.785)"
      fill="#ffffff"
    />
    <rect
      width="1.919"
      height="4.9439998"
      transform="translate(175.045,378.018)"
      fill="#ffffff"
      x="0"
      y="0"
    />
    <rect
      width="64"
      height="63.993999"
      transform="translate(128,361)"
      fill="none"
      x="0"
      y="0"
    />
  </g>
);
